import { SUPPLIERS_TYPES_IDS } from '@wyz/utils';
import { z } from 'zod';

export const SUPPLIERS_STATUSES = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
} as const;

export const supplierTypeSchema = z.object({
  id: z.enum(SUPPLIERS_TYPES_IDS),
  name: z.string(),
});

export const supplierPlatformSchema = z.object({
  supplier: z.object({
    id: z.number(),
    name: z.string(),
    supplierTypeId: z.number(),
  }),
});
export const anonymizedSupplierPlatformSchema = z.object({
  supplierPlatform: z.object({
    wyzOffer: z.boolean(),
    supplier: z.object({
      id: z.number(),
      name: z.string(),
      active: z.boolean(),
      centralStock: z.boolean(),
      code: z.string().nullable(),
      deliveryCountryId: z.number(),
      supplierType: supplierTypeSchema,
    }),
  }),
  deliveryCountryIds: z.array(z.number()),
});
